import { Button, Dialog, Group, Icon } from '@economic/taco';
import { Trans } from '@lingui/macro';
import { useNavigate } from 'react-router-dom';
import ExternalLink from '~/app/shared/components/ExternalLink';
import imgShakingHands from '~/app/shared/img/man-and-woman-shaking-hands.png';

interface Props {
    hide: () => void;
}

const ConnectedToPensoPay = ({ hide }: Props) => {
    const navigate = useNavigate();

    const goToInvoices = () => {
        navigate('/sales/invoicing/invoices');
    };

    return (
        <>
            <Dialog.Title>
                <Trans>You are good to go</Trans>
            </Dialog.Title>

            <div className="flex mt-4 justify-center">
                <img src={imgShakingHands} alt="" />
            </div>

            <div className="flex mt-8">
                <Trans>
                    You have now completed the first part of the Payment Link setup. You can now add payment links to your
                    invoices via "New invoice".
                </Trans>
            </div>

            <div className="flex mt-8">
                <Icon name="warning" className="yt-yellow-solid mr-3 rounded-full" />
                <strong className="mt-0.5">
                    <Trans>IMPORTANT</Trans>
                </strong>
            </div>

            <div className="flex mt-4">
                <Icon name="envelope" className="mr-3" />
                <div className="mt-0.5 flex flex-col">
                    <strong>
                        <Trans>Complete the application</Trans>
                    </strong>
                    <Trans>
                        You will soon receive an email from pensopay with a link to a KYC (know your customer) application. The
                        application must be submitted within 30 days and approved by pensopay before you can receive payments from
                        your customers.
                    </Trans>
                </div>
            </div>

            <div className="flex mt-4">
                <Icon name="document" className="mr-3" />
                <div className="mt-0.5 flex flex-col">
                    <strong>
                        <Trans>Send an invoice first</Trans>
                    </strong>
                    <Trans>
                        As part of this application, you must attach an invoice that has been paid through a payment link and
                        which indicates what you are selling. Therefore, we recommend that you only begin your application once
                        you have a paid invoice.
                    </Trans>
                </div>
            </div>

            <div className="flex mt-4">
                <Icon name="rating-payment-problems" className="mr-3" />
                <div className="mt-0.5 flex flex-col">
                    <strong>
                        <Trans>Transaction Limit</Trans>
                    </strong>
                    <Trans>
                        Until your application is approved, you can send invoices for a maximum of 10,000 DKK. When the limit is
                        reached, the function will be disabled.
                    </Trans>
                </div>
            </div>

            <div className="flex mt-4">
                <Icon name="book" className="mr-3" />
                <span className="mt-0.5">
                    <Trans>In the meantime, you can read more about how to use</Trans>{' '}
                    <ExternalLink href="https://www.e-conomic.dk/support/artikler/tilfoej-betalingslink-til-dine-faktura-skjult">
                        <Trans>Payment Link in e-copedia.</Trans>
                    </ExternalLink>
                </span>
            </div>

            <Group className="flex mt-6 justify-end">
                <Button onClick={hide}>
                    <Trans>Done</Trans>
                </Button>
                <Button appearance="primary" onClick={goToInvoices}>
                    <Trans>Go to invoices</Trans>
                </Button>
            </Group>
        </>
    );
};

export default ConnectedToPensoPay;
